import type { SerpSort } from '../model/types';

/** Порядок вариантов в шторке сортировки — как в макете. */
export const SERP_SORT_ORDER: readonly SerpSort[] = ['popular', 'priceAsc', 'priceDesc', 'rating'];

export const DEFAULT_SERP_SORT: SerpSort = 'popular';

/** Имя группы радиокнопок шторки: без него радиокнопки не переключают друг друга. */
export const SERP_SORT_RADIO_NAME = 'serp-sort';
